import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { topSidePartOfWebForPicher } from './parts/sideParts'
import { generateLiningsGradient } from 'src/util/canvas'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

const basketCheckCellSecond = async (
  ctx: CanvasRenderingContext2D,
  webColorSecond: CanvasGradient | 'white',
  x: number,
  y: number,
  numerator?: number
): Promise<void> => {
  const drawPath = () => {
    ctx.beginPath()
    if (numerator !== undefined && numerator !== 0) {
      ctx.save()
      ctx.rotate((numerator * Math.PI) / 180)
    }
    ctx.strokeStyle = '#282828'
    ctx.moveTo(563 + x, 120 + y)
    ctx.quadraticCurveTo(552 + x, 139 + y, 552 + x, 139 + y)
    ctx.quadraticCurveTo(564 + x, 147 + y, 572 + x, 158 + y)
    ctx.quadraticCurveTo(583 + x, 142 + y, 583 + x, 140 + y)
    ctx.quadraticCurveTo(575 + x, 127 + y, 563 + x, 120 + y)
    ctx.fill()
    ctx.stroke()
    if (numerator !== undefined) {
      ctx.restore()
    }
    ctx.closePath()
  }

  ctx.fillStyle = webColorSecond
  drawPath()
}

export const basketForPitcherWeb = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  await topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ-人差し指のジョイントパーツ
  await jointOfIndexFinger(ctx, webColor, laceColor, 3, 30, printLeatherTypeValue)
  await jointOfIndexFinger(ctx, webColor, laceColor, -24, 90, printLeatherTypeValue)
  await jointOfIndexFinger(ctx, webColor, laceColor, -45, 160, printLeatherTypeValue)
  await jointOfCatchFace(ctx, webColor, laceColor, -10, 12, printLeatherTypeValue)
  await jointOfCatchFace(ctx, webColor, laceColor, 38, 57, printLeatherTypeValue)
  await jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56, printLeatherTypeValue)
  await jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30, printLeatherTypeValue)
  await jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5, printLeatherTypeValue)

  // web本体のflatパーツ
  const drawWebBody = () => {
    ctx.beginPath()
    ctx.moveTo(549, 84) // 左上
    ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
    ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
    ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
    ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
    ctx.quadraticCurveTo(639, 320, 690, 285) // 右上
    ctx.quadraticCurveTo(655, 145, 549, 84) // 左上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawWebBody, webColor)

  ctx.beginPath()
  ctx.moveTo(582, 139) // 左上
  ctx.quadraticCurveTo(600, 148, 606, 169)
  ctx.moveTo(624, 196) // 左上
  ctx.quadraticCurveTo(638, 202, 644, 227)
  ctx.moveTo(564, 120) // 左上
  ctx.quadraticCurveTo(535, 161, 503, 229)
  ctx.moveTo(583, 140) // 左上
  ctx.quadraticCurveTo(533, 229, 533, 229)
  ctx.moveTo(608, 166) // 左上
  ctx.quadraticCurveTo(575, 205, 536, 260)
  ctx.moveTo(625, 193) // 左上
  ctx.quadraticCurveTo(569, 260, 566, 269)
  ctx.moveTo(644, 225) // 左上
  ctx.quadraticCurveTo(608, 253, 568, 299)
  ctx.moveTo(654, 252) // 左上
  ctx.quadraticCurveTo(622, 289, 578, 320)
  ctx.moveTo(523, 248) // 左上
  ctx.quadraticCurveTo(536, 262, 536, 262)
  ctx.moveTo(552, 283) // 左上
  ctx.quadraticCurveTo(566, 302, 566, 302)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 1段目

  const coordinates = { x0: 150, y0: 300, x1: 700, y1: 400 }
  const isLeatherPrint = printLeatherTypeValue && printLeatherTypeValue !== 'unselected' && printLeatherTypeValue !== 'none'
  const gradient = generateLiningsGradient(ctx, webColor, coordinates)
  const webPartsColor = isLeatherPrint ? 'white' : gradient

  await basketCheckCellSecond(ctx, webPartsColor, 0, 0)
  await basketCheckCellSecond(ctx, webPartsColor, 64, -58, 10)
  await basketCheckCellSecond(ctx, webPartsColor, 119, -128, 20)
  // 2段目
  await basketCheckCellSecond(ctx, webPartsColor, 22, -8, 5)
  await basketCheckCellSecond(ctx, webPartsColor, 83, -75, 15)
  // 3段目
  await basketCheckCellSecond(ctx, webPartsColor, -24, 42)
  await basketCheckCellSecond(ctx, webPartsColor, 43, -20, 10)
  await basketCheckCellSecond(ctx, webPartsColor, 100, -94, 20)
  // 4段目
  await basketCheckCellSecond(ctx, webPartsColor, -3, 35, 5)
  await basketCheckCellSecond(ctx, webPartsColor, 59, -10, 13)
  // 5段目
  await basketCheckCellSecond(ctx, webPartsColor, -45, 80, 1)
  await basketCheckCellSecond(ctx, webPartsColor, 20, 24, 10)
  await basketCheckCellSecond(ctx, webPartsColor, 82, -50, 20)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // バスケットの周り
  // 内側
  ctx.moveTo(560, 113) //左上
  ctx.quadraticCurveTo(527, 172, 500, 243) // 左下
  ctx.quadraticCurveTo(572, 335, 577, 335) // 右下
  ctx.quadraticCurveTo(632, 295, 673, 254) // 右上
  ctx.quadraticCurveTo(635, 161, 560, 113) // 左上
  // 外側
  ctx.moveTo(558, 107) //左上
  ctx.quadraticCurveTo(527, 172, 496, 243) // 左下
  ctx.quadraticCurveTo(572, 345, 575, 340) // 右下
  ctx.quadraticCurveTo(633, 303, 677, 253) // 右上
  ctx.quadraticCurveTo(635, 155, 558, 107) // 左上
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}

// 左Y軸用
const jointOfIndexFinger = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  x: number,
  y: number,
  printLeatherTypeValue?: string
) => {
  // 指袋とウェブのジョイント
  const drawJoint = () => {
    ctx.beginPath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#282828'
    ctx.moveTo(510 + x, 86 + y) // 左下_1
    ctx.quadraticCurveTo(512 + x, 90 + y, 514 + x, 84 + y) // 左下内
    ctx.quadraticCurveTo(513 + x, 80 + y, 513 + x, 80 + y) // 左内
    ctx.quadraticCurveTo(524 + x, 75 + y, 527 + x, 88 + y) // 右下内
    ctx.quadraticCurveTo(530 + x, 88 + y, 528 + x, 88 + y) // 右下外
    ctx.quadraticCurveTo(534 + x, 82 + y, 545 + x, 54 + y) // 右上
    ctx.quadraticCurveTo(529 + x, 45 + y, 522 + x, 51 + y) // 左上
    ctx.quadraticCurveTo(514 + x, 72 + y, 509 + x, 77 + y) // 左下
    ctx.quadraticCurveTo(510 + x, 86 + y, 510 + x, 86 + y) // 左下_1
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawJoint, webColor)
  // 断面の白色
  ctx.beginPath()
  ctx.lineWidth = 2.0
  ctx.strokeStyle = '#eee'
  ctx.moveTo(512 + x, 87 + y) // 左下
  ctx.quadraticCurveTo(511 + x, 80 + y, 511 + x, 80 + y) // 左上
  ctx.quadraticCurveTo(525 + x, 73 + y, 528 + x, 88 + y) // 右
  ctx.stroke()
  ctx.closePath()
  // lace ここから
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(513 + x, 88 + y) // 左下
  ctx.quadraticCurveTo(517 + x, 92 + y, 523 + x, 91 + y) // 右下
  ctx.quadraticCurveTo(527 + x, 87 + y, 523 + x, 83 + y) // 右上
  ctx.quadraticCurveTo(518 + x, 78 + y, 514 + x, 82 + y) // 左上
  ctx.quadraticCurveTo(513 + x, 88 + y, 513 + x, 88 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 側面ライン
  ctx.beginPath()
  ctx.lineWidth = 1.1
  ctx.strokeStyle = '#282828'
  ctx.moveTo(521 + x, 90 + y) // 下
  ctx.quadraticCurveTo(522 + x, 82 + y, 524 + x, 84 + y) // 上
  ctx.stroke()
  ctx.fillStyle = webColor
  ctx.closePath()
}

const jointOfCatchFace = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  x: number,
  y: number,
  printLeatherTypeValue?: string
) => {
  // 指袋とウェブのジョイント
  const drawJoint = () => {
    ctx.beginPath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#282828'
    ctx.moveTo(486 + x, 281 + y) // 左下
    ctx.quadraticCurveTo(515 + x, 315 + y, 515 + x, 315 + y) // 右下
    ctx.quadraticCurveTo(525 + x, 315 + y, 531 + x, 301 + y) // 右上
    ctx.quadraticCurveTo(500 + x, 266 + y, 500 + x, 266 + y) // 左上
    ctx.quadraticCurveTo(495 + x, 277 + y, 486 + x, 281 + y) // 左下
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawJoint, webColor)
  // laceここから
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(485 + x, 279 + y) // 左下
  ctx.quadraticCurveTo(491 + x, 279 + y, 495 + x, 272 + y) // 右下
  ctx.quadraticCurveTo(490 + x, 268 + y, 486 + x, 272 + y) // 左上
  ctx.quadraticCurveTo(485 + x, 279 + y, 485 + x, 279 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const jointOfThumbFinger2 = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  x: number,
  y: number,
  printLeatherTypeValue?: string
) => {
  // 指袋とウェブのジョイント
  const drawJoint = () => {
    ctx.beginPath()
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#282828'
    ctx.moveTo(609 + x, 370 + y) // 左下
    ctx.quadraticCurveTo(628 + x, 370 + y, 638 + x, 353 + y) // 右下
    ctx.quadraticCurveTo(641 + x, 345 + y, 635 + x, 340 + y) // 右上
    ctx.quadraticCurveTo(626 + x, 347 + y, 609 + x, 355 + y) // 左上
    ctx.quadraticCurveTo(610 + x, 352 + y, 609 + x, 370 + y) // 左下
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawJoint, webColor)
  // 断面ここから
  ctx.beginPath()
  ctx.lineWidth = 2.0
  ctx.strokeStyle = '#eee'
  ctx.moveTo(612 + x, 358 + y) // 左
  ctx.quadraticCurveTo(615 + x, 355 + y, 612 + x, 368 + y) // 右下
  ctx.stroke()
  ctx.strokeStyle = '#282828'
  ctx.closePath()
  // laceここから
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.moveTo(598 + x, 366 + y) //左下
  ctx.quadraticCurveTo(607 + x, 369 + y, 611 + x, 365 + y) // 右下
  ctx.quadraticCurveTo(613 + x, 359 + y, 608 + x, 359 + y) // 右上
  ctx.quadraticCurveTo(601 + x, 358 + y, 601 + x, 358 + y) // 左上
  ctx.quadraticCurveTo(597 + x, 361 + y, 598 + x, 366 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
